import {
  Container,
  Section,
  Comments,
  Header,
  AvatarContainer,
  Avatar,
  Comment,
  HeadTitle,
  Content,
  Wrapper,
} from './styles';
import { Collapse } from 'react-collapse';
import { useState, useEffect } from 'react';

import MessageInput from '../../../../components/TasksModal/MessageRender/MessageInput';
import Send2 from '../../../../assets/TaskModalIcons/Send2';
import ArrowDown from '../../../../assets/icons/DropArrowdown';
import { trackPromise } from 'react-promise-tracker';
import { useDispatch } from 'react-redux';

import { fetchFlowChat } from '../../../../state/chat/reducers';
import { useSelector } from 'react-redux';
import { handleNewMessage } from '../../../../state/chat/actions';
import { classifyDataByDate } from '../utils';

const CommentSection = ({ active, flow }) => {
  const [openCollapse, setOpenCollapse] = useState({
    openToday: true,
    openLW: false,
    openLM: false,
  });

  const chat = useSelector((state) => state.chat.flow);
  const user = useSelector((state) => state.auth.user);

  const log = classifyDataByDate(chat.log);

  const [comment, setComment] = useState('');

  const dispatch = useDispatch();

  const flowStatus = useSelector(
    (state) => state.activedFlows.pane.flow.status
  );
  const flowIsFinished = flowStatus && flowStatus[0] === 'finished';

  async function newMessage(msg) {

    if (!msg) {
      return
    }

    await trackPromise(
      dispatch(
        handleNewMessage({
          userId: user._id,
          ref: { flowId: flow._id },
          username: user.username,
          message: msg,
          type: 'flow',
        })
      ).then(() => setComment('')),
      'chat'
    );
  }

  async function getMessages(refId) {
    await trackPromise(
      dispatch(fetchFlowChat({ refId })).catch((err) => console.log(err)),
      'fetching-chat-flow'
    );
  }

  useEffect(() => {
    getMessages(flow._id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Container active={active}>
      {active && (
        <>
          <Comments>
            <div>
              <Header
                open={openCollapse.openToday}
                onClick={() =>
                  setOpenCollapse(
                    (prev) =>
                    (prev = {
                      openToday: !prev.openToday,
                      openLW: false,
                      openLM: false,
                    })
                  )
                }
              >
                <span>Hoje</span>
                <ArrowDown height="0.70625rem" color="#212326" />
              </Header>
              <Collapse isOpened={openCollapse.openToday}>
                <Section>
                  {log.today.reverse().map((item, i) => (
                    <Wrapper key={i}>
                      <AvatarContainer>
                        <Avatar src={item.avatarURL} />
                      </AvatarContainer>
                      <Comment>
                        <HeadTitle title={item.createdAt}>
                          {item.username}, at {item.until}
                        </HeadTitle>
                        <Content>{item.message}</Content>
                      </Comment>
                    </Wrapper>
                  ))}
                </Section>
              </Collapse>
              <Header
                open={openCollapse.openLW}
                onClick={() =>
                  setOpenCollapse(
                    (prev) =>
                    (prev = {
                      openToday: false,
                      openLW: !prev.openLW,
                      openLM: false,
                    })
                  )
                }
              >
                <span>Últimos 7 Dias</span>
                <ArrowDown height="0.70625rem" color="#212326" />
              </Header>
              <Collapse isOpened={openCollapse.openLW}>
                <Section>
                  {log.lastWeek.reverse().map((item, i) => (
                    <Wrapper key={i}>
                      <AvatarContainer>
                        <Avatar src={item.avatarURL} />
                      </AvatarContainer>
                      <Comment>
                        <HeadTitle title={item.createdAt}>
                          {item.username}, at {item.until}
                        </HeadTitle>
                        <Content>{item.message}</Content>
                      </Comment>
                    </Wrapper>
                  ))}
                </Section>
              </Collapse>
              <Header
                open={openCollapse.openLM}
                onClick={() =>
                  setOpenCollapse(
                    (prev) =>
                    (prev = {
                      openToday: false,
                      openLW: false,
                      openLM: !prev.openLM,
                    })
                  )
                }
              >
                <span>Últimos Meses</span>
                <ArrowDown height="0.70625rem" color="#212326" />
              </Header>
              <Collapse isOpened={openCollapse.openLM}>
                <Section>
                  {log.beforeLastWeek.reverse().map((item, i) => (
                    <Wrapper key={i}>
                      <AvatarContainer>
                        <Avatar src={item.avatarURL} />
                      </AvatarContainer>
                      <Comment>
                        <HeadTitle title={item.createdAt}>
                          {item.username}, at {item.until}
                        </HeadTitle>
                        <Content>{item.message}</Content>
                      </Comment>
                    </Wrapper>
                  ))}
                </Section>
              </Collapse>
            </div>
            <div>
              {!flowIsFinished ? (
                <MessageInput
                  newMessage={newMessage}
                  setValue={(e) => setComment(e)}
                  style={{ width: '14.125rem', marginBottom: '1.2rem' }}
                  value={comment}
                  Icon={() => null}
                  placeholder="Digite um comentário..."
                  buttonConfirm={() => console.log('aq')}
                  buttonConfirmText={() => <Send2 />}
                />
              ) : null}
            </div>
          </Comments>
        </>
      )}
    </Container>
  );
};

export default CommentSection;
